import React from 'react';
import LegalLayout from './LegalLayout';

const Accessibility = () => (
  <LegalLayout eyebrow="Legal" title="Accessibility Statement" updated="1 January 2026">
    <p>Elevate Medical Clinics is committed to providing an accessible online experience for all patients and visitors. We aim to conform with the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA.</p>

    <h2>What we do</h2>
    <ul>
      <li>Use clear typography and sufficient colour contrast for readability.</li>
      <li>Support keyboard navigation and semantic HTML structure.</li>
      <li>Provide alternative text on informative images.</li>
      <li>Design interactive elements with clear focus states.</li>
      <li>Design layouts that adapt to mobile, tablet and desktop screens.</li>
    </ul>

    <h2>At the clinic</h2>
    <p>Our Mount Lawley clinic offers step-free access and support for patients with mobility, visual or hearing needs. Please let reception know in advance so we can prepare for your visit.</p>

    <h2>Report an issue</h2>
    <p>If you experience an accessibility barrier on our website or at the clinic, please email <a href="mailto:reception@elevatemedicalclinics.com.au">reception@elevatemedicalclinics.com.au</a> or call +61 432 809 498. We will respond and, where possible, resolve the issue promptly.</p>
  </LegalLayout>
);

export default Accessibility;
